import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import EventBus from "../utils/EventBus";
import oemService from "../services/oem.service";

export const createoem = createAsyncThunk(
  "api/createoem",
  async (stateData, thunkAPI) => {
    try {
      const data = await oemService.createOEM(stateData);
      return { oemdata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getalloem = createAsyncThunk(
  "api/getalloem",
  async (thunkAPI) => {
    try {
      const data = await oemService.getAllOEM();
      return { oemdata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getoembyid = createAsyncThunk(
  "api/getoembyid",
  async (oem_id, thunkAPI) => {
    try {
      const data = await oemService.getOEMbyid(oem_id);
      return { oemdata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateoem = createAsyncThunk(
  "api/updateoem",
  async ({oem_id, formData}, thunkAPI) => {
    try {
      const data = await oemService.updateOEM(oem_id, formData);
      return { oemdata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deleteoem = createAsyncThunk(
  "api/deleteoem",
  async ({oem_id}, thunkAPI) => {
    try {
      const data = await oemService.deleteOEM(oem_id);
      return { oemdata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState ={
    oems: [],
    oem: null,
    message:null
}

const oemSlice = createSlice({
  name: "api",
  initialState,
  extraReducers: {
    [createoem.fulfilled]: (state, action) => {
      state.oems.push(action.payload.oemdata.data)
      state.message = "OEM Created Succefully"
      return state;
    },
    [createoem.rejected]: (state, action) => {
      state.message = action.payload.oemdata.message
      return state;
    },
    [getalloem.fulfilled]: (state, action) => {
    state.oems = action.payload.oemdata.data
    state.message = null
    return state;
  },
  [getoembyid.rejected]: (state, action) => {
    state.oem = action.payload.oemdata
    state.message = action.payload.oemdata.message
    return state;
  },
  [getoembyid.fulfilled]: (state, action) => {
    state.oem = action.payload.oemdata.data
    return state;
  },
  [getalloem.rejected]: (state, action) => {
    state.message = action.payload.oemdata.message
    return state;
  },
  [updateoem.fulfilled]: (state, action) => {
    const {
      arg: { oem_id },
    } = action.meta;
    if (oem_id) {
      state.oems = state.oems.map((item) =>
        item.oem_id === oem_id ? action.payload.oemdata.data : item
      );
    };
    state.message = "OEM Updated Successfully"
  },
  [updateoem.rejected]: (state, action) => {
    state.message = action.payload.oemdata.message
  },
  [deleteoem.fulfilled]: (state, action) => {
    const {
      arg: { oem_id },
    } = action.meta;
    if (oem_id) {
      state.oems = state.oems.filter((item) => item.oem_id !== oem_id);
    };
    state.message = action.payload.oemdata.message
  },
  [deleteoem.rejected]: (state, action) => {
    state.message = action.payload.oemdata.message
  },
  },
});

const { reducer } = oemSlice;
export default reducer;